import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { getRouteByName } from 'Helpers/Routes';

import Head from 'Components/helpers/Head';

import Hero from 'Components/public/videoCaseStudy/Hero';
import Challenge from 'Components/public/videoCaseStudy/Challenge';
import WhyUs from 'Components/public/videoCaseStudy/WhyUs';
import Solution from 'Components/public/videoCaseStudy/Solution';
import SolutionV2 from 'Components/public/videoCaseStudy/SolutionV2';
import Results from 'Components/public/videoCaseStudy/Results';
import ResultsV2 from 'Components/public/videoCaseStudy/ResultsV2';
import Checkout from 'Components/public/videoCaseStudy/Checkout';

const data = {
    'nivea': require('./data/nivea').default,
    'mandel': require('./data/mandel').default,
    'urban-partnership-bank': require('./data/urbanPartnershipBank').default,
    'viselio': require('./data/viselio').default,
    'berri-fit': require('./data/berriFit').default,
    'at-a-glance': require('./data/atAGlance').default
};


export default class CaseStudy extends React.Component {
    static propTypes = {
        params: PropTypes.shape({
            slug: PropTypes.string.isRequired,
            salesmanSlug: PropTypes.string
        }).isRequired
    };
    static defaultProps = {};


    render() {
        const { params } = this.props;

        const csData = data[params.slug];

        return (
            <div className="container-video-case-study">
                <Head
                    title={csData.meta.title}
                    description={csData.meta.description}
                    image={csData.meta.ogImage}
                    robots={`index, follow`}
                    canonical={getRouteByName('videoCaseStudy', { slug: params.slug }).path}
                />
                {csData.hero && csData.hero.visible && <Hero data={csData.hero} />}
                {csData.challenge && csData.challenge.visible && <Challenge data={csData.challenge} />}
                {csData.whyUs && csData.whyUs.visible && <WhyUs data={csData.whyUs} />}
                {csData.solution && csData.solution.visible && <Solution data={csData.solution} />}
                {csData.solutionv2 && csData.solutionv2.visible && <SolutionV2 data={csData.solutionv2} />}
                {csData.results && csData.results.visible && <Results data={csData.results} />}
                {csData.resultsv2 && csData.resultsv2.visible && <ResultsV2 data={csData.resultsv2} />}
                {csData.checkout && csData.checkout.visible && <Checkout data={csData.checkout} salesmanSlug={params.salesmanSlug} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/global/VideoCaseStudy/index.js